import * as constants from './actions';

import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    actionCancelled: false,
    isFormSubmitting: false
};

export default function electionReminder(state = initialState, { type, payload }) {
    switch (type) {
        case constants.ELECTION_REMINDER_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.ELECTION_REMINDER_SUBMITTING:
            return {
                ...state,
                isFormSubmitting: payload.isFormSubmitting
            };
        case constants.ELECTION_REMINDER_COMPLETED:
            return {
                ...state,
                completeElectionReminder: payload,
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.ELECTION_REMINDER_CANCELED:
            return {
                ...state,
                actionCancelled: true,
                actionCancelledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.ELECTION_REMINDER_ERROR:
            return {
                ...state,
                electionReminderError: payload
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        default:
            return state;
    }
}
